import React from 'react';
import { useTranslation } from 'react-i18next';

const History = () => {
  const { t } = useTranslation();

  const values = [
    t('history.valuesCollaboration'),
    t('history.valuesSharing'),
    t('history.valuesInnovation'),
    t('history.valuesResponsibility'),
  ];

  return (
    <section className="bg-slatex-50 py-20 lg:py-28">
      <div className="container-x">
        <div className="max-w-2xl" data-aos="fade-up">
          <span className="eyebrow">{t('ui.eyebrowStory')}</span>
          <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-ink">{t('history.title')}</h2>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-3" data-aos="fade-up" data-aos-delay="150">
          {/* Established */}
          <div className="rounded-2xl border border-slatex-200 bg-white p-8 shadow-soft">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-50 text-brand-600">
              <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></svg>
            </span>
            <h3 className="mt-5 text-lg font-bold text-ink">{t('history.establishedTitle')}</h3>
            <p className="mt-3 text-sm leading-relaxed text-slatex-600">{t('history.establishedText')}</p>
          </div>

          {/* Values */}
          <div className="rounded-2xl border border-slatex-200 bg-white p-8 shadow-soft">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-50 text-brand-600">
              <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" /></svg>
            </span>
            <h3 className="mt-5 text-lg font-bold text-ink">{t('history.valuesTitle')}</h3>
            <ul className="mt-4 space-y-3">
              {values.map((v, i) => (
                <li key={i} className="flex gap-2.5 text-sm text-slatex-600">
                  <span className="mt-1.5 h-1.5 w-1.5 flex-none rounded-full bg-brand-500" />
                  {v}
                </li>
              ))}
            </ul>
          </div>

          {/* Vision */}
          <div className="rounded-2xl border border-slatex-200 bg-white p-8 shadow-soft">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-50 text-brand-600">
              <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" /><circle cx="12" cy="12" r="3" /></svg>
            </span>
            <h3 className="mt-5 text-lg font-bold text-ink">{t('history.visionTitle')}</h3>
            <p className="mt-3 text-sm leading-relaxed text-slatex-600">{t('history.visionText')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default History;
